import React from "react";
import { Typography, Accordion, AccordionSummary } from "@material-ui/core";
import moment from "moment";

export default props => {
    return props.bookings.map(booking => {
        return (
            <Accordion key={"jouanlExpansion" + booking.id} expanded={false}>
                <AccordionSummary id={booking.id}>
                    <div>
                        <Typography>
                            Booking d. {moment(new Date(Number(booking.from))).format("DD/MM/YYYY, HH:mm:ss")} -{" "}
                            {booking.nameFirst} {booking.nameLast}
                        </Typography>
                    </div>
                </AccordionSummary>
            </Accordion>
        );
    });
};
